export default defineNuxtRouteMiddleware((to) => {
  const { loggedIn, fetch: refreshSession } = useUserSession();

  const isClient = import.meta.client;
  if (to.query?.accessToken && to.name === "campaign-slug") return;
  if (to.name === "login" || to.name === "set-password" || to.name === "reset-password") return;

  if (!loggedIn.value) {
    const redirect = useCookie<string>("redirectUrl", {
      path: "/",
      sameSite: "lax",
    });
    redirect.value = to.fullPath; // SSR-safe persistence

    return navigateTo({ name: "login", query: { redirect: to.fullPath } });
  }

  // refresh the session
  refreshSession();
});
